import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import { useAppSelector } from '../../../../store/hooks';

const FAQs: React.FC = () => {
	const faqs = useAppSelector((state) => state.system.faqs);
	const [expandedIdx, setExpandedIdx] = useState<number | null>(null);

	const onChange = (expanded: boolean, idx: number) => {
		if (expanded) {
			setExpandedIdx(idx);
		} else {
			setExpandedIdx(null);
		}
	};

	return (
		<Stack width={'100%'} padding={1} data-testid={'faqs-tab-content'}>
			{faqs.map((faq, i) => {
				return (
					<Accordion
						expanded={expandedIdx === i}
						onChange={(_, expanded) => onChange(expanded, i)}
						key={`${faq.link}-content`}
						slotProps={{
							heading: {
								component: 'div',
							},
						}}
						data-testid={`${faq.link}-content`}
					>
						<AccordionSummary>
							<Typography variant="h6" component={'span'} fontWeight={'bold'}>
								{faq.question}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Typography data-testid={`${faq.link}-answer`}>{faq.answer}</Typography>
						</AccordionDetails>
					</Accordion>
				);
			})}
		</Stack>
	);
};

export default FAQs;
